module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-79.95e90711.svg";